// extracted by mini-css-extract-plugin
export var cardContainer = "_q2-0";
export var cardHeader = "_q2-2";
export var collapsedState = "_q2-3";
export var dragHandle = "_q2-5";
export var dragHandleIcon = "_q2-6";
export var dragging = "_q2-1";
export var titleArea = "_q2-4";